import React from 'react';
import { Bold } from 'lucide-react';
import { RichInput } from '@/components/ai-tools/RichInput';
import { FileLinks } from '@/components/common/FileLinks';

interface LetterBodyProps {
  content: string;
  setContent: (content: string) => void;
  files?: Record<string, string>;
  insertBold: (e: React.MouseEvent) => void;
}

export const CoverLetterBody = ({
  content,
  setContent,
  files,
  insertBold
}: LetterBodyProps) => {
  return (
    <div className="flex-1 flex flex-col pt-0 relative overflow-hidden bg-transparent rounded-b-xl">
      <div className="flex-1 flex flex-col w-full relative overflow-y-auto">
        <div className="sticky top-2 z-10 flex justify-center w-full pointer-events-none mb-4">
          <div className="pointer-events-auto flex items-center bg-white dark:bg-slate-800 p-1 rounded-lg border border-slate-200 dark:border-slate-700 dark:shadow-sm">
            <button
              onMouseDown={insertBold}
              className="p-1.5 px-3 rounded-md text-xs font-semibold flex items-center gap-1.5 hover:bg-slate-100 dark:hover:bg-slate-700 transition-colors text-slate-700 dark:text-slate-300 cursor-pointer"
              title="Make selected text bold (Ctrl+B)"
            >
              <Bold className="w-3.5 h-3.5" />
              Bold
            </button>
          </div>
        </div>
        <div className="flex-1 flex flex-col min-h-max px-6 lg:px-10">
          <RichInput
            value={content}
            onChange={setContent}
            className="w-full flex-1 shrink-0 pt-2 lg:pt-2 text-sm text-slate-900 dark:text-slate-300 bg-transparent focus:outline-none resize-none whitespace-pre-wrap leading-relaxed font-serif text-justify"
          />
          {/* Spacer to allow full scroll padding */}
          <div className="h-10 lg:h-14 shrink-0 w-full" />
        </div>
      </div>
      {files && Object.keys(files).length > 0 && (
        <div className="absolute bottom-4 left-4 right-4 pointer-events-none">
          <FileLinks files={files} />
        </div>
      )}
    </div>
  );
};
